import CarWishlistContainer from "../../components/car/Wishlist";

const CarWishlist = () => {
  return <CarWishlistContainer />;
};

export default CarWishlist;
